module.exports = __webpack_public_path__ + "img/enterprise-institution-1.7289ce34.png";